import { DateTime, Info } from "luxon";
import last from "~/kernel/arrays/last";
import isNil from "~/kernel/validation/isNil";
import isNumber from "~/kernel/numbers/isNumber";
import isString from "~/kernel/strings/isString";

export default function parseDate(value: unknown) {
  if (isNil(value)) {
    return invalidDate();
  }

  if (isNumber(value)) {
    return DateTime.fromMillis(value).toJSDate();
  }

  if (value instanceof Date) {
    return DateTime.fromJSDate(value).toJSDate();
  }

  if (!isString(value)) {
    return invalidDate();
  }

  if (hasZone(value)) {
    const format = "yyyy-MM-dd'T'HH:mm:ss z";
    return DateTime.fromFormat(value, format).toJSDate();
  }

  return DateTime.fromISO(value).toJSDate();
}

function invalidDate() {
  return new Date("Invalid");
}

function hasZone(dateString: string) {
  const value = last(dateString.split(" "));
  const zone = Info.normalizeZone(value);
  return zone.isValid;
}
